const IError = (body) => {
    console.log(body)
}

export default IError